<div class="container-capped">
  <div>
    <button class="btn btn-blue" (click)="updateIgPages()">Daily</button>
    <pre dir="ltr" class="p-1 border text-left">
      {{updateIgPagesResponse|json}}
    </pre>

  </div>
  <div>
    <div class="p-2 d-flex flex-wrap">
      <div class="ml-2 flex-fill">
        <input type="text" placeholder="instagram page username" dir="ltr" [(ngModel)]="igPage" />
      </div>
      <button class="btn btn-blue" (click)="dump()">Dump Page</button>
    </div>
    <pre dir="ltr" class="p-1 border text-left">
      {{dumpResponse|json}}
    </pre>

  </div>
  <div>
    <button class="btn btn-blue" (click)="getInsights()">Get Insights</button>
    <pre dir="ltr" class="p-1 border text-left">
      {{insightsResponse|json}}
    </pre>

  </div>

  <div>
    <div class="p-2 d-flex flex-wrap">
      <div class="ml-2 flex-fill">
        <input type="text" [(ngModel)]="apiUrl" placeholder="api url" dir="ltr">
      </div>
      <button class="btn btn-blue" (click)="apiRequest()">Api Request</button>
    </div>
    <pre dir="ltr" class="p-1 border text-left">
      {{apiResponse|json}}
    </pre>

  </div>
  <div>
    <h5 class="pointer f-blue" (click)="_display.settings=!_display.settings">settings</h5>
    <div *ngIf="_display.settings">
      <textarea dir="ltr" [(ngModel)]="settings" rows="10"></textarea>
      <button class="btn btn-secondary" (click)="saveSettings()">Save Settings</button>
    </div>
  </div>
  <div>
    <h5 class="pointer f-blue" (click)="_display.token=!_display.token">FB Token</h5>
    <div *ngIf="_display.token">
      <div class="p-2 d-flex flex-wrap">
        <div class="ml-2 flex-fill">
          <input type="text" [(ngModel)]="scope" placeholder="scope" dir="ltr">
        </div>
        <button class="btn btn-blue" (click)="connect()">Request access from FB</button>
      </div>
      <div class="p-2" *ngIf="authResponse?.status != 'connected'">
        <h3>not connected</h3>
      </div>
      <div>
        <h3>authResponse:</h3>
        <pre dir="ltr" class="p-1 border text-left">
          {{authResponse|json}}
        </pre>
      </div>
      <div>
        <h3>exchangeResponse:</h3>
        <button class="btn btn-blue" (click)="getLongAccessTokens()">Get long access tokens</button>
        <pre dir="ltr" class="p-1 border text-left">
          {{exchangeResponse|json}}
        </pre>
      </div>
      <div>
        <div class="p-2 d-flex flex-wrap">
          <div class="ml-2 flex-fill">
            <input type="text" [(ngModel)]="debugAccessToken" placeholder="api url" dir="ltr">
          </div>
          <button class="btn btn-blue" (click)="debugToken()">Debug Toeken</button>
        </div>
        <pre dir="ltr" class="p-1 border text-left">
          {{debugTokenResponse|json}}
        </pre>

      </div>

      <div class="p-2" *ngIf="authResponse?.status == 'connected'">
        <h3>meResponse:</h3>
        <pre dir="ltr" class="p-1 border text-left">
          {{meResponse|json}}
        </pre>

      </div>

    </div>
  </div>


</div>